/**
 * @generated SignedSource<<7be52c6257f57bed57ac06d6182bc208>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ShiftInformation_ScheduleShift",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditScheduleShiftTimeStart"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditScheduleShiftTimeEnd"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditScheduleShiftEvent"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditScheduleShiftDescription"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useScheduleShiftTags_scheduleShift"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ScheduleShiftEditBreaks_scheduleShift"
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignmentTypeId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Schedule",
            "kind": "LinkedField",
            "name": "schedule",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentUserPermissions",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ScheduleShift",
    "abstractKey": null
};
node.hash = "176ac19b2e5be382cebed2addd412708";
export default node;
